<template>
    <card class="">
        <slot name="header"></slot>
        <form @submit="handleForm($event)" class="dynamic-form">

            <!-- create participation pool if the entity is `programme` -->
            <div class="card-body" v-if="isPoolRequired">
                <!-- <p class="card-text text-bold text-center" v-if="participants_pool.length < max_participants">Create participation pool consting of no more than <b>{{ max_participants }}</b> participants</p>
                <p class="card-text text-center" v-if="participants_pool.length >= max_participants">Your participation pool consists of the following participants:</p> -->
                <div class="pool-creator mb-1">
                    <PoolForm @on-pool="gotParticipants" :min_participants="min_participants" :max_participants="max_participants"></PoolForm>
                </div>
                <hr>
            </div>

            <!-- to show list of team as and when they are added -->
            <div class="card-body"  v-if="local_form.length <= max_teams">
                <div class="row team" v-for="(team, index) in local_form"  :key="`T${index}`">
                    <div class="col-sm-11">
                        <div class="col-sm-12" v-if="(max_teams > 1)">
                            Team {{ index+1 }}
                        </div>
                        <div class="row pt-2">
                            <div class="col-sm-4"   v-for="(input) in team"  :key="input.name">
                                <h6 v-if="input.value && input.value != ''"> <small>{{ input.displayname }}</small> <br> {{ input.value }}</h6>    
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-1 pt-2">
                        <n-button class="pull-right m-0" type="danger" size="sm" round icon simple @click.native="deleteTeam(team)">
                            <i class="now-ui-icons ui-1_simple-remove"></i>
                        </n-button>
                    </div>
                </div>
            </div>

            <!-- to show form of team creation or single form -->
            <div class="card-body" v-if="local_form.length < max_teams">
                <div class="row justify-content-center">
                    <div class="col-sm-6 mb-3"   v-for="(input) in form"  :key="input.name">
                        <CustomInputs :input="input" :pool="getPool(input.fieldtype)" :login="login" :user="user"></CustomInputs>    
                    </div>
                    <!-- to show add to list button only when multiple teams are required for an event/programme -->
                    <!-- update: show button in both scenarios -->
                    <div class="col-sm-4 pt-3" v-if="(max_teams > 1) && (local_form.length <= max_teams)">
                        <n-button  @click.native="addTeam" type="primary" round simple block> 
                            <i class="now-ui-icons ui-1_simple-add"></i> Add Selected Participant(s)
                        </n-button>
                    </div>
                </div>
            </div>
            <!-- show events slots only if the entity type is parent, events need not show events again -->
            <slot name="events" v-if="entity == 'programme'"></slot>

            <div class="text-center">
                <div class="col-sm-12 text-center text-sm" :class="alert.type" v-if="alert.message">{{ alert.message }}</div>
                <input v-if="showSubmit" type="submit" :value="(final_price > 0) ? `Register by making payment of ₹${final_price_trimmed} for ${title}` : `Register for ${title}`" class="btn btn-default btn-round" :class="{ 'btn-success' : withSubmit && isFormValid }" :disabled="!withSubmit && isFormValid">
                <p v-if="!isOpen">Registrations will open on: {{ openingTime }}</p>
            </div>
        </form>

    </card>
</template>

<script>

import { Card, Tabs, TabPane, RegisterForm } from 'src/components'
import CustomInputs from './CustomInputs'
import PoolForm from './PoolForm'

import { mapGetters } from 'vuex';

export default {
    name: 'DynamicForm',
    components:{
        Card,
        CustomInputs,
        PoolForm,
        Tabs, 
        TabPane,
        RegisterForm
    },
    props:{
        entity: String,
        form: [Object, Array],
        title: String,
        action: String,
        price: {
            type: [Number, String],
            coerce: function (val) {
                return parseFloat(val) * 1
            }
        },
        slug: String,
        showSubmit: {
            type: Boolean,
            default: true
        },
        withSubmit: {
            type: Boolean,
            default: false
        },
        max_teams: {
            type: Number,
            default: 1
        },
        min_participants: {
            type: Number,
            default: 1
        },
        max_participants: {
            type: Number,
            default: 1
        },
        login: {
            type: Boolean,
            default: false
        },
        pool: {
            type: Boolean,
            default: false
        },
        multipleEntry: {
            type: Boolean,
            default: true
        },
        batches: {
            type: [Array, String],
            default: () => []
        },
        departments: {
            type: Array,
            default: () => []
        },
        participants_pool: {
            type: Array,
            default: () => []
        },
        events: {
            type: Array,
            default: () => []
        },
        programme: Object,
        isOpen: {
            type: Boolean,
            default: false
        },
        open_date: [Date, String],
    },
    mounted(){
        this.$nextTick(() => {
            this.local_pool = Object.assign([], this.participants_pool)
        })

        // let user = localStorage.getItem('app_user')
        // this.user = (user) ? JSON.parse(user) : null;

        this.user = this.$currentUser

        if(this.login && this.user){
            // returns first index of the occurance of the input with student or teacher as fieldtype
            let input = this.form.find((input) => {
                return input.fieldtype == 'student' || input.fieldtype == 'teacher'
            })
            if(input){
                input.value = this.user.register_no
                input.readonly = true
            }
        }
    },
    data(){
        return {
            local_form: [],
            local_pool: [],
            user: null,
            alert: {
                type: 'text-info',
                message: ''
            },
            isFormValid: false
        }
    },
    watch: {
        form: {
            handler: function (inputs, oldInputs) {
                inputs.forEach((input) => {
                    if(input.dependentOn !== null){
                        let dependentField = this.form.find(el => el.name === input.dependentOn);
                        if(dependentField)
                            input.render = dependentField.value;
                    }
                })

                if(this.login && this.user){
                    // returns first index of the occurance of the input with student or teacher as fieldtype
                    let input = inputs.find((input) => {
                        return input.fieldtype == 'student' || input.fieldtype == 'teacher'
                    })
                    if(input){
                        input.value = this.user.register_no
                        input.readonly = true
                    }
                }

                //emit form on change
                // this.$emit('on-change', this.form)]
                this.validation(false)
            },
            deep: true
        },
        // local_form: {
        //     handler: function (teams, oldTeams) {
        //         //emit form on change
        //         this.$emit('on-change', this.local_form)
        //     },
        //     deep: true
        // },
        participants_pool: {
            handler: function(pool, oldPool){
                this.local_pool = Object.assign([], this.participants_pool)
            }
        }
    },
    methods: {
        validation(shouldSubmit){
            let isValid = true
            
            this.alert = {type: 'text-info', message: ''}
            
            if(this.entity == 'programme'){
                if(!this.isPoolRequired || (this.participants_pool.length >= this.min_participants && this.participants_pool.length <= this.max_participants)){
                    // check for required fields
                    let somethingRequired = this.form.some((input) => {
                        if(input.dependentOn !== null && input.render === false){
                            // for inputs who are dependant and not eligible for render
                            // no need to check their required or value
                            return false
                        }

                        return (input.required && (input.value === null || input.value === undefined || input.value === ''))
                    })
                    if(somethingRequired){
                        this.alert.type = 'text-danger';
                        this.alert.message = `Please check all the required fields.`;
                        isValid = false;
                    }

                    // check for uniformity in a single team
                    let isUnique = this.form.some((input) => {
                        return this.form.some((item) => {
                            if((input.fieldtype === 'participant') || (input.fieldtype === 'student') || (input.fieldtype === 'teacher')){
                                if((item.fieldtype === 'participant') || (item.fieldtype === 'student') || (item.fieldtype === 'teacher')){
                                    if((item.name !== input.name) && (item.value === input.value) && (item.value !== null || item.value !== '')){
                                        return true;
                                    }
                                }
                            }
                            return  false;
                        })
                    })
                    if(isUnique){
                        console.log("🚀 ~ file: DynamicForm.vue ~ line 259 ~ validation ~ isUnique", isUnique)
                        this.alert.type = 'text-danger';
                        this.alert.message = `Cannot use same participant multiple times in a team.`;
                        isValid = false
                    }
                }
                else{
                    this.alert.type = 'text-danger';
                    this.alert.message = `Participant requirement parameters are not fullfilled. Need atleast ${this.min_participants} - ${this.max_participants} participants.`;
                    isValid = false
                }
            }
            else if(this.entity == 'event') {
                if(this.max_teams > 1 && this.local_form.length < 1){
                    this.alert.type = 'text-danger';
                    this.alert.message = `Need atleast 1 Team to be filled.`;
                    isValid = false
                }
                else{
                    // ok to process the form
                    // check for required fields
                    let somethingRequired = this.form.some((input) => {
                        if(input.dependentOn !== null && input.render === false){
                            // for inputs who are dependant and not eligible for render
                            // no need to check their required or value
                            return false
                        }
                        return (input.required && (input.value === null || input.value === undefined || input.value === ''))
                    })
                    if(somethingRequired){
                        this.alert.type = 'text-danger';
                        this.alert.message = `Please check all the required fields.`;
                        isValid = false
                    }

                    // check for uniformity in a single team
                    let isUnique = this.form.some((input) => {
                        return this.form.some((item) => {
                            if((input.fieldtype === 'participant') || (input.fieldtype === 'student') || (input.fieldtype === 'teacher')){
                                if((item.fieldtype === 'participant') || (item.fieldtype === 'student') || (item.fieldtype === 'teacher')){
                                    if((item.name !== input.name) && (item.value === input.value) && (item.value !== null || item.value !== '')){
                                        return true;
                                    }
                                }
                            }
                            return  false;
                        })
                    })
                    if(isUnique){
                        this.alert.type = 'text-danger';
                        this.alert.message = `Cannot use same participant multiple times in a team.`;
                        isValid = false
                    }
                }
            }
            console.log('test');
            // check for validity of check-boxes
            let anyCheckboxEmpty = this.form.some((input) => (input.fieldtype == 'checkbox' && input.value.length == 0 && input.required == true))
            console.log('Validation', anyCheckboxEmpty, this.form.find((input) => (input.fieldtype == 'checkbox' && input.value.length == 0 && input.required == true)));
            if(anyCheckboxEmpty){
                this.alert.type = 'text-danger';
                this.alert.message = `Please select at least one value for checkbox.`;
                isValid = false
            }
            console.log('valid', isValid);
            this.isFormValid = isValid
            if(isValid){
                if(shouldSubmit && this.withSubmit){
                    // this.alert.type = 'text-success';
                    // this.alert.message = `Your form is successfully submitted.`;
                    // emit out or use this.form

                    console.log('final_form', this.final_form)
                    this.$emit('on-submit', this.final_form)

                    // var myform = document.createElement("form");
                    
                    // var payload = document.createElement("input");
                    // payload.value = JSON.stringify(this.final_form);
                    // payload.name = "payload";
                    // myform.appendChild(payload);

                    // var headers = document.createElement("input");
                    // headers.value = JSON.stringify(this.tokens);
                    // headers.name = "headers";
                    // myform.appendChild(headers);

                    // myform.action = `${process.env.VUE_APP_BASE_URL}/tukio/users/register`;
                    // myform.method = "post";
                    // document.body.appendChild(myform);
                    // myform.submit();
                    // console.log('submit');

                }
                else{
                    this.$emit('on-form-update', {validity: isValid, form: this.final_form})
                }
            }

        },
        handleForm(event){
            event.preventDefault();
            console.log('check', this.isFormValid);
            if(this.isFormValid){
                this.$loading({
                    lock: true,
                    text: 'Loading Please Wait ...',
                    background: 'rgba(255, 255, 255, 0.85)'
                });
                this.validation(true);
            }
            else{
                this.alert.type = 'text-danger';
                this.alert.message = `Please check all the required fields.`;
                return false
            }
        },
        gotParticipants(pool){
            this.$emit('on-pool', Object.assign([], pool))
            this.alert = {type: 'text-info', message: ''}
        },
        addTeam(){
            this.alert = {type: 'text-info', message: ''}
            let newForm = []

            // check for missing fields
            let isMissingFields = this.form.some((el) => {
                return (el.required && (el.value === null || el.value === undefined || el.value === ''))
            })
            if(isMissingFields){
                this.alert.type = 'text-danger';
                this.alert.message = `Please fill all required fields.`;
                return false
            }

            // check for uniformity in a single team
            let isUnique = this.form.some((input) => {
                return this.form.some((item) => {
                    if((input.fieldtype === 'participant') || (input.fieldtype === 'student') || (input.fieldtype === 'teacher')){
                        if((item.fieldtype === 'participant') || (item.fieldtype === 'student') || (item.fieldtype === 'teacher')){
                            if((item.name !== input.name) && (item.value === input.value) && (item.value !== null || item.value !== '')){
                                return true;
                            }
                        }
                    }
                    return  false;
                })
            })
            if(isUnique){
                this.alert.type = 'text-danger';
                this.alert.message = `Cannot use same participant multiple times in a team.`;
                return false
            }

            // check for duplicate teams
            let isDuplicate = false
            if(this.local_form.length > 0){
                isDuplicate = this.local_form.some((team) => {
                    return team.some((input) => {
                        return this.form.some((item) => {
                            return (item.value === input.value) && (item.value !== null && item.value !== '')
                        })
                    })
                })
            }
            if(isDuplicate){
                this.alert.type = 'text-danger';
                this.alert.message = `Cannot use same participants for next team.`;
                return false
            }
                
            this.form.forEach((input) => {
                let el = Object.assign({}, input)
                if(this.max_teams > 1)
                    input.value = null
                newForm.push(el)
            })
            this.local_form.push(Object.assign([], newForm))
            this.$nextTick(() => {
                this.alert = {type: 'text-info', message: ''}
            })
            
        },
        deleteTeam(team){
            this.local_form.splice(this.local_form.indexOf(team), 1)
            this.$nextTick(() => {
                this.alert = {type: 'text-info', message: ''}
            })
        },
        getPool(fieldtype){
            let ret =[]
            switch(fieldtype){
                case 'participant' : ret = this.local_pool;        break;
                case 'student' :     ret = this.batches;           break;
                case 'teacher' :     ret = this.departments;       break;
            }
            return ret
        },
        calculateFormPrice(form){
            let price = 0
            if(form)
                form.forEach(input => {
                    if(input.value != null && input.value !== "" && input.price != null){
                        if(input.dependentOn !== null && input.render == false){
                            // for inputs who are dependant and not eligible for render
                            input.price = 0
                            price += parseInt(input.price)
                        }
                        else{
                            switch(input.fieldtype){
                                case 'file':
                                case 'text': 
                                case 'email':
                                    price += parseInt(input.price)
                                break;
                                case 'switch':
                                    if(typeof(input.value) == "string")
                                        price += (input.value === 'true') ? parseInt(input.price) : 0;
                                    else
                                        price += (input.value) ? parseInt(input.price) : 0;
                                break;
                                case 'radio':
                                case 'select-single':
                                case 'select-multiple':
                                    price += parseInt(input.value.split(':::').pop())
                                break;
                                case 'number':
                                    input.price = parseInt(input.value) * input.factor // value ~ user input (5ppl), factor ~ amount for each (100/person)
                                    price += parseInt(input.price)
                                break;
                                case 'checkbox':
                                    input.value.forEach(val => {
                                        price += parseInt(val.split(':::').pop())
                                    })
                                break;
                                case 'participant':
                                case 'student':
                                case 'teacher':
                                    price += parseInt(input.price)
                                break;
                                default:
                                    price += parseInt(input.price)
                                break;
                            }
                        }
                    }
                });
            return price
        }
    },
    computed: {
        ...mapGetters({
            headers: "getHeaders",
            tokens: "getAuthTokens" 
        }),
        final_price(){

            // normal form calulations
            let formExtras = this.calculateFormPrice(this.form)
            
            // special form calculations
            if(this.entity == 'programme'){
                if(this.isPoolRequired && (this.participants_pool.length >= this.min_participants)){
                    // has pool and atleast 1 member in it
                    return ((this.price * this.participants_pool.length) + formExtras)
                }
                else if(this.isPoolRequired && (this.participants_pool.length < this.min_participants)){
                    // has pool but no members
                    return ((this.price * this.min_participants) + formExtras)
                }
            }
            else { // entity is 'event'
                if(this.max_teams > 1 && this.local_form.length >= 1){
                    // has teams and has atleast 1 filled ~ local_form.length >= 1 [local_form is only filled when atleast one team is added]
                    let teamExtras = 0;
                    this.local_form.forEach((team) => {
                        teamExtras += this.calculateFormPrice(team)
                    })
                    return (this.price + teamExtras)
                }
                else if(this.max_teams > 1 && this.local_form.length < 1){
                    // no teams filled
                    return (this.price)
                }
            }
            // fail safe
            return (this.price + formExtras);
        },
        final_price_trimmed(){
            return parseInt(this.final_price);
        },
        isPoolRequired(){
            if(this.pool && this.entity == 'programme' && (this.batches.length < 1 || this.login))
                return true
            return false
        },
        // fetch details from the form object
        firstname(){
            if(this.login && this.user){
                return this.user.name;
            }
            else{
                let index = this.form.findIndex(inp => inp.name === 'name');
                if(index >=0 && this.form[index].value != null && this.form[index].value != "")
                // return (index >= 0) ? this.form[index].value.split(' ')[0] : null;
                return (index >= 0) ? this.form[index].value : null;
                else return null;
            }
        },
        email(){
            if(this.login && this.user){
                return this.user.mail;
            }
            else{
                let index = this.form.findIndex(inp => inp.name === 'email');
                if(index >=0 && this.form[index].value && this.form[index].value != "")
                return (index >= 0) ? this.form[index].value : null;
                else return null;
            }
        },
        phone(){
            if(this.login && this.user){
                return null; // not saving phone number of students in DB
            }
            else{
                let index = this.form.findIndex(inp => inp.name === 'phone');
                if(index >=0 && this.form[index].value && this.form[index].value != "")
                return (index >= 0) ? this.form[index].value : null; 
                else return null;
            }
        },
        participants(){
            let participants = []
            if(this.local_form.length > 0){
                this.local_form.forEach((team) => {
                    team.forEach((input) => {
                        if(['participant', 'student', 'teacher'].includes(input.fieldtype))
                            if(input.value && input.value != "")
                                participants.push(input.value)
                    })
                })
            }
            else{
                this.form.forEach((input) => {
                    if(['participant', 'student', 'teacher'].includes(input.fieldtype))
                        if(input.value && input.value != "")
                            participants.push(input.value)
                })
            }
            return participants
        },
        final_form(){
            return {
                name: this.firstname,
                email: this.email,
                mobile: this.phone,

                participants_pool: this.local_pool,
                // to be used for programme registrations (group)
                form: Object.assign([],(this.local_form.length > 0) ?  this.local_form : this.form), // use local_form when teams are required, else use the normal form,

                programme: this.programme,

                title: this.title,
                slug: this.slug,
                participants: Object.assign([], this.participants),

                price: this.final_price,
                entity: this.entity,
                // to be used for event wise registrations
                events: this.entity == 'event' ? [
                    {
                        title: this.title,
                        slug: this.slug,
                        participants: Object.assign([], this.participants),
                        price: this.final_price,
                        form: Object.assign([],(this.local_form.length > 0) ?  this.local_form : this.form), // use local_form when teams are required, else use the normal form
                    }
                ] : [],
                user_id: this.user ? this.user.user_id : null,
                txn_id: "4234817340587583475",
            }
        },
        openingTime: function(){
            let date = new Date(this.open_date);
            return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' });
        },
    }
}
</script>

 <style lang="scss">
    .dynamic-form label{
        margin-left: 15px;
        margin-bottom: 0px!important;
    }
    .dynamic-form .el-tag, .el-tag.el-tag--info{
        padding: 4px 5px;
    }

    .dynamic-form{
        .badge-info, 
        .el-tag, 
        .el-tag.el-tag--info, 
        .badge-info[href]:focus, 
        .el-tag[href]:focus, 
        .badge-info[href]:hover, 
        .el-tag[href]:hover{
            border-color: #fff;
        }

        .bootstrap-switch{
            margin-left: 10px;
            margin-bottom: 3px;
        }

        .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default{
            color: #555;
        }
    }

    .team{
        
        border-bottom: solid 1px #eee;
        margin-bottom: 5px;
    }

    .team:first-child{
        border-top: solid 1px #eee;
    }
</style>
